import { Tooltip } from 'antd';
import { BsPlayCircle, BsHandIndexThumb, BsHeadphones, BsImage, BsLightbulb } from 'react-icons/bs';
import { IoText } from 'react-icons/io5';

const SupportedMedia = (props) => {

    const { media } = props;

    if (!Array.isArray(media) || media.length === 0) return 'N/A';

    return media.map(m => {
        switch (m) {
            case 'Audio':
                return (
                    <Tooltip key="audio" title="Audio content">
                        <span style={{marginRight: 8}}><BsHeadphones /></span>
                    </Tooltip>
                )
            case 'Image':
                return (
                    <Tooltip key="image" title="Image content">
                        <span style={{marginRight: 8}}><BsImage /></span>
                    </Tooltip>
                )
            case 'Interactive':
                return (
                    <Tooltip key="interactive" title="Interactive content">
                        <span style={{marginRight: 8}}><BsHandIndexThumb /></span>
                    </Tooltip>
                )
            case 'Learn2Learn':
                return (
                    <Tooltip key="learn2learn" title="Learn2Learn content">
                        <span style={{marginRight: 8}}><BsLightbulb /></span>
                    </Tooltip>
                )
            case 'Text':
                return (
                    <Tooltip key="text" title="Textual content">
                        <span style={{marginRight: 8}}><IoText /></span>
                    </Tooltip>
                )
            case 'Video':
                return (
                    <Tooltip key="video" title="Video content">
                        <span style={{marginRight: 8}}><BsPlayCircle /></span>
                    </Tooltip>
                )
            default:
                return 'N/A';
        }
    });

}

export default SupportedMedia;